/* --- BAG DATA --- */
const CAT_COLORS = {
  // Category encoding. The theme already uses Tailwind values (#ca8a04,
  // #ef4444, #fbbf24, #737373), so these are Tailwind 600/700 — saturated
  // enough to separate on #101010, dark enough to carry white badge text,
  // and shifted off the gold accent so 'briefcase' no longer reads as a
  // brand colour.
  backpack:  '#2563eb',
  sling:     '#7c3aed',
  tote:      '#ea580c',
  duffle:    '#0891b2',
  travel:    '#059669',
  briefcase: '#a16207',
  pouch:     '#db2777',
};

/* UrbanCred product links.
   `h` is a product handle, rendered as a root-relative /products/<handle>.
   Relative on purpose: the canonical domain is urbancred.com (no www), and a
   relative path also survives a theme preview, where an absolute URL jumps
   the visitor out to the live site.
   NOT /collections/bags/products/<handle> — Shopify 404s that form for any
   product outside the collection.
   `h` is only set where the product is ACTIVE and has a live storefront URL.
   Audited 2026-09-16: 30 of 83 handles were stale (25 deleted, 5 back to
   draft) and were set to null. Re-audit before each release — a handle is a
   claim about the store's present state, and stores change. */

// Brand website for "Where to Buy" links
const BRAND_RETAILERS = {
  // Pack Hacker brands
  "Trakke": { url:'https://trakke.co.uk/collections/all', label:"Trakke" },
  "The North Face": { url:'https://www.thenorthface.com/en-us/bags-and-gear', label:"The North Face" },
  "Kelty": { url:'https://www.kelty.com/packs/', label:"Kelty" },
  "Patagonia": { url:'https://www.patagonia.com/shop/backpacks-bags', label:"Patagonia" },
  "Eagle Creek": { url:'https://www.eaglecreek.com/collections/bags', label:"Eagle Creek" },
  "Sandqvist": { url:'https://www.sandqvist.com/collections/bags', label:"Sandqvist" },
  "Mission Workshop": { url:'https://missionworkshop.com/collections/bags', label:"Mission Workshop" },
  "Western Rise": { url:'https://westernrise.com/collections/bags', label:"Western Rise" },
  "ULA Equipment": { url:'https://ula-equipment.com/product-category/packs/', label:"ULA Equipment" },
  "REI": { url:'https://www.rei.com/c/packs', label:"REI" },
  "Shimoda": { url:'https://shimodadesigns.com/collections/all', label:"Shimoda" },
  "Tropicfeel": { url:'https://tropicfeel.com/collections/backpacks', label:"Tropicfeel" },
  "Timbuk2": { url:'https://www.timbuk2.com/collections/all-bags', label:"Timbuk2" },
  "Samsonite": { url:'https://shop.samsonite.com/backpacks/', label:"Samsonite" },
  "Salkan": { url:'https://salkan.co/collections/all', label:"Salkan" },
  "Red Oxx": { url:'https://www.redoxx.com/bags', label:"Red Oxx" },
  "Pakt": { url:'https://www.paktbags.com/collections/all', label:"Pakt" },
  "Pacsafe": { url:'https://www.pacsafe.com/collections/all', label:"Pacsafe" },
  "Gossamer Gear": { url:'https://gossamergear.com/collections/packs', label:"Gossamer Gear" },
  "Lowepro": { url:'https://www.lowepro.com/us-en/', label:"Lowepro" },
  "Deuter": { url:'https://www.deuter.com/us-en/shop/backpacks', label:"Deuter" },
  "Incase": { url:'https://incase.com/collections/bags', label:"Incase" },
  "Sherpani": { url:'https://sherpani.com/collections/all', label:"Sherpani" },
  "Mous": { url:'https://uk.mous.co/collections/bags', label:"Mous" },
  "North St. Bags": { url:'https://northstbags.com/collections/all', label:"North St. Bags" },
  "Chrome Industries": { url:'https://www.chromeindustries.com/collections/bags', label:"Chrome Industries" },
  "Moment": { url:'https://www.shopmoment.com/shop/bags', label:"Moment" },
  "Black Diamond": { url:'https://www.blackdiamondequipment.com/en_US/packs-bags/', label:"Black Diamond" },
  "Troubadour Goods": { url:'https://troubadourgoods.com/collections/all', label:"Troubadour Goods" },
  "Carl Friedrik": { url:'https://carlfriedrik.com/collections/backpacks', label:"Carl Friedrik" },
  "Solgaard": { url:'https://solgaard.co/collections/backpacks', label:"Solgaard" },
  "Arcido": { url:'https://arcido.com/collections/all', label:"Arcido" },
  "DSPTCH": { url:'https://dsptch.com/collections/bags', label:"DSPTCH" },
  "Travelpro": { url:'https://www.travelpro.com/collections/backpacks', label:"Travelpro" },
  "Away": { url:'https://www.awaytravel.com/bags', label:"Away" },
  "WaterField Designs": { url:'https://www.sfbags.com/collections/bags', label:"WaterField Designs" },
  "Vanquest": { url:'https://www.vanquest.com/backpacks', label:"Vanquest" },
  "Triple Aught Design": { url:'https://tripleaughtdesign.com/collections/bags-packs', label:"Triple Aught Design" },
  "L.L.Bean": { url:'https://www.llbean.com/llb/shop/1000000276', label:"L.L.Bean" },
  "lululemon": { url:'https://shop.lululemon.com/c/bags/_/N-8s6', label:"lululemon" },
  "CamelBak": { url:'https://www.camelbak.com/en/packs', label:"CamelBak" },
  "Outdoor Research": { url:'https://www.outdoorresearch.com/collections/packs-bags', label:"Outdoor Research" },
  "Filson": { url:'https://www.filson.com/bags-luggage/', label:"Filson" },
  "Mountain Hardwear": { url:'https://www.mountainhardwear.com/equipment/', label:"Mountain Hardwear" },
  "Hyperlite Mountain Gear": { url:'https://www.hyperlitemountaingear.com/collections/packs', label:"Hyperlite Mountain Gear" },
  "Sea to Summit": { url:'https://seatosummit.com/collections/packs-bags', label:"Sea to Summit" },
  "The Brown Buffalo": { url:'https://thebrownbuffalo.com/collections/all', label:"The Brown Buffalo" },
  "Monos": { url:'https://monos.com/collections/bags', label:"Monos" },
  "Carhartt": { url:'https://www.carhartt.com/collections/bags-luggage', label:"Carhartt" },
  "Herschel Supply Co.": { url:'https://herschel.com/shop/backpacks', label:"Herschel Supply Co." },
  "Arterra": { url:'https://arterrasupply.com/collections/all', label:"Arterra" },
  "Topologie": { url:'https://topologie.com/collections/bags', label:"Topologie" },
  "Owala": { url:'https://owalalife.com/collections/bags', label:"Owala" },
  "Orbitkey": { url:'https://www.orbitkey.com/collections/bags', label:"Orbitkey" },
  "SLNT": { url:'https://slnt.com/collections/bags', label:"SLNT" },
  "Long Weekend": { url:'https://longweekendco.com/collections/all', label:"Long Weekend" },
  "Harber London": { url:'https://harberlondon.com/collections/bags', label:"Harber London" },
  "Allett": { url:'https://www.allett.com/collections/bags', label:"Allett" },
  "FREITAG": { url:'https://www.freitag.ch/en/bags', label:"FREITAG" },
  "Billingham": { url:'https://www.billingham.co.uk/camera-bags/', label:"Billingham" },
  "QWSTION": { url:'https://www.qwstion.com/collections/all-bags', label:"QWSTION" },
  "RUX": { url:'https://rux.design/collections/all', label:"RUX" },
  // Pack Hacker brands
  'Tortuga':               { url:'https://www.tortugabackpacks.com/collections/all', label:'Tortuga' },
  'Osprey':                { url:'https://www.osprey.com/collections/backpacks', label:'Osprey' },
  'Thule':                 { url:'https://www.thule.com/en-us/backpacks', label:'Thule' },
  'Tom Bihn':              { url:'https://www.tombihn.com/collections/backpacks', label:'Tom Bihn' },
  'Code of Bell':          { url:'https://codeofbell.com/collections/all', label:'Code of Bell' },
  'Evergoods':             { url:'https://evergoods.us/collections/bags', label:'Evergoods' },
  'Black Ember':           { url:'https://blackember.com/collections/bags', label:'Black Ember' },
  'Able Carry':            { url:'https://ablecarry.com/collections/bags', label:'Able Carry' },
  'Boundary Supply':       { url:'https://boundarysupply.com/collections/bags', label:'Boundary Supply' },
  'Peak Design':           { url:'https://www.peakdesign.com/collections/bags', label:'Peak Design' },
  'AER':                   { url:'https://aersf.com/collections/bags', label:'AER' },
  'Matador':               { url:'https://matadorup.com/collections/bags', label:'Matador' },
  'Bellroy':               { url:'https://bellroy.com/collections/bags', label:'Bellroy' },
  'Pioneer Carry':         { url:'https://pioneerbagpackco.com/collections/bags', label:'Pioneer Carry' },
  'Modern Dayfarer':       { url:'https://moderndayfarer.com/collections/all', label:'Modern Dayfarer' },
  '1733':                  { url:'https://1733supply.com/collections/all', label:'1733 Supply' },
  'Rework':                { url:'https://rework.us/collections/bags', label:'Rework' },
  'Inside Line Equipment': { url:'https://ilequipment.com/collections/bags', label:'ILE' },
  'Gordon Miller':         { url:'https://gordonmiller.jp', label:'Gordon Miller JP' },
  'Topo Designs':          { url:'https://topodesigns.com/collections/bags', label:'Topo Designs' },
  'Attitude Supply':       { url:'https://attitudesupply.com/collections/all', label:'Attitude Supply' },
  'Porter':                { url:'https://www.yoshidakaban.com/en/brand/porter', label:'Porter (Yoshida)' },
  // Notion brands
  '5.11 Tactical':         { url:'https://www.511tactical.com/bags-and-packs', label:'5.11 Tactical' },
  'Alpaka':                { url:'https://alpakagear.com/collections/bags', label:'Alpaka' },
  'Alpha One Niner':       { url:'https://alphaoneninergear.com/collections/all', label:'Alpha One Niner' },
  "Arc'teryx":             { url:'https://arcteryx.com/collections/bags', label:"Arc'teryx" },
  'Arktype':               { url:'https://arktype.com/collections/all', label:'Arktype' },
  'Baboon to the Moon':    { url:'https://baboon.com/collections/bags', label:'Baboon to the Moon' },
  'Brevite':               { url:'https://brevitebag.com/collections/all', label:'Brevite' },
  'Cabin Zero':            { url:'https://cabinzero.com/collections/backpacks', label:'Cabin Zero' },
  'Cotopaxi':              { url:'https://cotopaxi.com/collections/bags', label:'Cotopaxi' },
  'Ctactical':             { url:'https://ctactical.com/collections/all', label:'Ctactical' },
  'Day Owl':               { url:'https://dayowl.co/collections/bags', label:'Day Owl' },
  'Fjallraven':            { url:'https://www.fjallraven.com/us/en-us/bags-and-luggage', label:'Fjallraven' },
  'GORUCK':                { url:'https://www.goruck.com/collections/backpacks', label:'GORUCK' },
  'Gregory':               { url:'https://www.gregorypacks.com/bags-packs/daypacks/', label:'Gregory' },
  'Halfday':               { url:'https://halfday.com/collections/backpacks', label:'Halfday' },
  'Hanchor':               { url:'https://hanchor.com/collections/all', label:'Hanchor' },
  'Heimplanet':            { url:'https://heimplanet.com/collections/bags', label:'Heimplanet' },
  'LTT':                   { url:'https://www.lttstore.com/collections/bags', label:'LTT Store' },
  'Millican':              { url:'https://millican.com/collections/bags', label:'Millican' },
  'Minaal':                { url:'https://www.minaal.com/collections/bags', label:'Minaal' },
  'Mystery Ranch':         { url:'https://www.mysteryranch.com/collections/daypacks', label:'Mystery Ranch' },
  'Nomatic':               { url:'https://www.nomatic.com/collections/backpacks', label:'Nomatic' },
  'tomtoc':                { url:'https://www.tomtoc.com/collections/bags', label:'tomtoc' },
  'Wandrd':                { url:'https://www.wandrd.com/collections/bags', label:'Wandrd' },
  'YETI':                  { url:'https://www.yeti.com/collections/bags', label:'YETI' },
};

/* ---
   RELEASE NOTES
   Newest first. Add an entry whenever bags are added, specs are
   corrected, or the tool itself changes — a reference is only worth
   citing if a reader can see it is still being maintained.
--- */
const RELEASES = window.RELEASES || [];
const VERSION = (RELEASES[0] || {}).v || "1.0";

const CDN = 'https://cdn.shopify.com/s/files/1/0055/2383/2950/';

const bags = window.BAG_DATA || [];

/* --- STATE --- */
let state = {
  search: '',
  cats: new Set(),           // empty = all
  brands: new Set(),         // empty = all
  maxVol: 80,
  sort: 'featured',
  // Table leads on desktop: with no product images, the cards are spec tiles
  // and the sortable table is the faster way through 869 rows. Phones still
  // open on the grid, because the table needs horizontal scrolling there.
  view: window.innerWidth <= 820 ? 'grid' : 'table',
  compare: [],               // max 4 bag ids
  tableSort: null,
  tableSortDir: 'asc',
};

/* --- HELPERS --- */
const $ = id => document.getElementById(id);
const fmtVol = v => v == null ? '—' : v + 'L';
const fmtWt = w => w == null ? '—' : (w >= 1000 ? (w/1000).toFixed(2)+'kg' : w+'g');

function catColor(cat) { return CAT_COLORS[cat] || '#666'; }

/* Badge styling follows the store's own badge idiom — a pale fill with dark
   text (sale: #da2127 on #fff, "new": #000 on #FFDF00) rather than a solid
   saturated block. Keeps 262 sling cards from shouting over the gold brand. */
const CAT_BADGE = {
  backpack:  ['#dbeafe', '#1d4ed8'],
  sling:     ['#ede9fe', '#6d28d9'],
  tote:      ['#ffedd5', '#c2410c'],
  duffle:    ['#cffafe', '#0e7490'],
  travel:    ['#d1fae5', '#047857'],
  briefcase: ['#fef3c7', '#92400e'],
  pouch:     ['#fce7f3', '#be185d'],
};
function catBadge(cat) {
  const [bg, fg] = CAT_BADGE[cat] || ['#e5e5e5', '#404040'];
  return `background:${bg};color:${fg}`;
}

function filtered() {
  return bags.filter(b => {
    if (state.search) {
      const q = state.search.toLowerCase();
      const hay = [b.name, b.brand, b.mat, b.cat, b.laptop].filter(Boolean).join(' ').toLowerCase();
      if (!hay.includes(q)) return false;
    }
    if (state.cats.size && !state.cats.has(b.cat)) return false;
    if (state.brands.size && !state.brands.has(b.brand)) return false;
    if (b.vol != null && b.vol > state.maxVol) return false;
    return true;
  });
}

function sorted(list) {
  const s = [...list];
  switch(state.sort) {
    case 'vol-asc':    s.sort((a,b) => (a.vol||0) - (b.vol||0)); break;
    case 'vol-desc':   s.sort((a,b) => (b.vol||0) - (a.vol||0)); break;
    case 'name-asc':   s.sort((a,b) => a.name.localeCompare(b.name)); break;
    case 'brand-asc':  s.sort((a,b) => a.brand.localeCompare(b.brand)); break;
    case 'cat-asc':
    case 'cat-desc': {
      // group by bag type, in the same order the sidebar lists them
      const order = Object.keys(CAT_COLORS);
      const dir = state.sort === 'cat-desc' ? -1 : 1;
      s.sort((a,b) =>
        dir * (order.indexOf(a.cat) - order.indexOf(b.cat))
        || a.brand.localeCompare(b.brand)
        || a.name.localeCompare(b.name));
      break;
    }
    default:           // featured: Code of Bell first, then brand, then name
      s.sort((a,b) => {
        const aCob = a.brand === 'Code of Bell' ? 0 : 1;
        const bCob = b.brand === 'Code of Bell' ? 0 : 1;
        if (aCob !== bCob) return aCob - bCob;
        return a.brand.localeCompare(b.brand) || a.name.localeCompare(b.name);
      });
  }
  return s;
}

/* --- RENDER SIDEBAR --- */
function renderSidebar() {
  const all = bags;

  // Categories
  const catCounts = {};
  bags.forEach(b => { catCounts[b.cat] = (catCounts[b.cat]||0)+1; });
  const allCats = Object.entries(CAT_COLORS).filter(([cat]) => catCounts[cat]);  // hide empty categories

  const catContainer = $('catPills');
  catContainer.innerHTML = `
    <div class="cat-pill ${state.cats.size===0?'active':''}" data-cat="all">
      <span class="cat-dot" style="background:#737373"></span>
      <span class="cat-label">All bags</span>
      <span class="cat-count">${bags.length}</span>
    </div>
    ${allCats.map(([cat, color]) => `
    <div class="cat-pill ${state.cats.has(cat)?'active':''}" data-cat="${cat}">
      <span class="cat-dot" style="background:${color}"></span>
      <span class="cat-label">${cat.charAt(0).toUpperCase()+cat.slice(1)}</span>
      <span class="cat-count">${catCounts[cat]||0}</span>
    </div>`).join('')}
  `;

  catContainer.querySelectorAll('.cat-pill').forEach(el => {
    el.addEventListener('click', () => {
      const cat = el.dataset.cat;
      if (cat === 'all') { state.cats.clear(); }
      else {
        if (state.cats.has(cat)) state.cats.delete(cat);
        else state.cats.add(cat);
      }
      render();
    });
  });

  // Brands
  const allBrands = [...new Set(bags.map(b=>b.brand))].sort();
  const brandContainer = $('brandList');
  brandContainer.innerHTML = allBrands.map(br => `
    <div class="brand-item ${state.brands.has(br)?'active':''}" data-brand="${br}">
      <div class="chk">${state.brands.has(br)?'✓':''}</div>
      <span>${br}</span>
    </div>`).join('');

  brandContainer.querySelectorAll('.brand-item').forEach(el => {
    el.addEventListener('click', () => {
      const br = el.dataset.brand;
      if (state.brands.has(br)) state.brands.delete(br);
      else state.brands.add(br);
      render();
    });
  });
}

/* --- RENDER GRID --- */
function renderGrid(list) {
  const grid = $('bagGrid');
  if (!list.length) { grid.innerHTML=''; return; }

  // The card only has to help you decide whether to open the bag — brand,
  // type, name, volume. Everything else lives in the detail view.
  grid.innerHTML = list.map(b => {
    const sel = state.compare.includes(b.id);
    return `
    <div class="bag-card ${sel?'selected':''}" id="card-${b.id}"
         role="button" tabindex="0" data-id="${b.id}"
         aria-label="${esc(b.brand)} ${esc(b.name)} — open details">
      <div class="card-body">
        <div class="card-meta">
          <span class="card-brand">${b.brand}</span>
          <span class="cat-label-badge" style="${catBadge(b.cat)}">${b.cat}</span>
          <div class="cmp-check ${sel?'checked':''}" title="Add to compare"
               onclick="event.stopPropagation();toggleCompare(${b.id})">${sel?'✓':''}</div>
        </div>
        <div class="card-name">${b.name}</div>
        <div class="card-vol">${b.vol != null ? fmtVol(b.vol) : '—'}</div>
      </div>
    </div>`;
  }).join('');
}

/* --- RENDER TABLE --- */
function renderTable(list) {
  const tbody = $('bagTableBody');
  if (!list.length) { tbody.innerHTML=''; return; }

  tbody.innerHTML = list.map(b => {
    const sel = state.compare.includes(b.id);
    return `
    <tr class="${sel?'selected':''}" id="row-${b.id}" data-id="${b.id}" tabindex="0">
      <td><div class="tbl-cmp-check" title="Add to compare"
              onclick="event.stopPropagation();toggleCompare(${b.id})">${sel?'✓':''}</div></td>
      <td>
        <div class="tbl-name">${b.name}</div>
        <div class="tbl-brand">${b.brand}</div>
      </td>
      <td><span class="tbl-cat" style="${catBadge(b.cat)}">${b.cat}</span></td>
      <td class="tbl-vol">${fmtVol(b.vol)}</td>
      <td>${fmtWt(b.wt)}</td>
      <td>${b.laptop || '—'}</td>
      <td class="tbl-feat">${b.mat || '—'}</td>
      <td class="tbl-open">Details →</td>
    </tr>`;
  }).join('');
}

/* --- RENDER COMPARE BAR --- */
function renderCompareBar() {
  const bar = $('cmpBar');
  const slots = $('cmpSlots');

  if (!state.compare.length) { bar.classList.remove('vis'); return; }
  bar.classList.add('vis');

  const MAX = 4;
  let html = '';
  state.compare.forEach(id => {
    const b = bags.find(x=>x.id===id);
    if (!b) return;
    html += `
      <div class="cmp-slot">
        <div class="cmp-slot-info">
          <div class="cmp-slot-name">${b.name}</div>
        </div>
        <button class="cmp-rm" onclick="toggleCompare(${b.id})">✕</button>
      </div>`;
  });

  const empties = MAX - state.compare.length;
  for (let i=0; i<empties; i++) {
    html += `<div class="cmp-empty-slot">+ Add bag</div>`;
  }

  slots.innerHTML = html;
  $('cmpGoBtn').disabled = state.compare.length < 2;
  $('cmpGoBtn').style.opacity = state.compare.length < 2 ? '0.5' : '1';
}

/* --- COMPARE MODAL --- */
function openCompareModal() {
  const ids = state.compare;
  if (ids.length < 2) return;
  const sel = ids.map(id => bags.find(b=>b.id===id)).filter(Boolean);

  const rows = [
    ['Category',    b => `<span class="tbl-cat" style="${catBadge(b.cat)}">${b.cat}</span>`],
    ['Volume',      b => b.vol != null ? `<strong>${fmtVol(b.vol)}</strong>` : '—'],
    ['Weight',      b => fmtWt(b.wt)],
    ['Dimensions',  b => b.dims || '—'],
    ['Material',    b => b.mat || '—'],
    ['Laptop Fit',  b => b.laptop || '—'],
    ['Carry Style', b => b.carry.join(', ')],
    ['Key Features',b => b.feats.length ? b.feats.join(' · ') : '—'],
    ['Where to Buy', b => {
      const uc = b.h ? `<a href="/products/${b.h}" target="_blank" style="color:var(--accent);font-size:11px;display:block;margin-bottom:4px;font-weight:700">UrbanCred →</a>` : '';
      const br = BRAND_RETAILERS[b.brand] ? `<a href="${BRAND_RETAILERS[b.brand].url}" target="_blank" style="color:var(--text-muted);font-size:11px;display:block;font-weight:700">${BRAND_RETAILERS[b.brand].label} →</a>` : '';
      return uc + br;
    }],
  ];

  const heads = sel.map(b => `
    <th class="bag-head">
      <div class="bag-head-name">${b.name}</div>
      <div class="bag-head-brand">${b.brand}</div>
      <div class="bag-head-links">
        ${b.h ? `<a class="bag-head-link" href="/products/${b.h}" target="_blank">UrbanCred →</a>` : ''}
        ${BRAND_RETAILERS[b.brand] ? `<a class="bag-head-link-alt" href="${BRAND_RETAILERS[b.brand].url}" target="_blank">${BRAND_RETAILERS[b.brand].label} →</a>` : ''}
      </div>
    </th>`).join('');

  const bodyRows = rows.map(([label, fn]) => `
    <tr>
      <td class="row-label">${label}</td>
      ${sel.map(b => `<td class="row-val">${fn(b)}</td>`).join('')}
    </tr>`).join('');

  $('cmpTbl').innerHTML = `
    <thead><tr><th class="row-label"></th>${heads}</tr></thead>
    <tbody>${bodyRows}</tbody>
  `;

  $('modalBg').classList.add('vis');
  document.body.style.overflow = 'hidden';
}

function closeModal() {
  $('modalBg').classList.remove('vis');
  if (!anyModalOpen()) document.body.style.overflow = '';
}

/* ---
   BAG DETAIL
   The card is a summary; this is the record. Every field lives here,
   including the ones too long or too sparse to sit on a card.
--- */
function anyModalOpen() {
  return ['modalBg','detailBg','notesBg'].some(id => $(id).classList.contains('vis'));
}

// bag data is scraped, so it can contain quotes and angle brackets — escape
// anything going into an attribute or into innerHTML
function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

let lastFocus = null;

function openDetail(id) {
  const b = bags.find(x => x.id === id);
  if (!b) return;
  // re-opening to refresh the compare button must not overwrite the element
  // we have to hand focus back to on close
  if (!$('detailBg').classList.contains('vis')) lastFocus = document.activeElement;

  $('detailBrand').textContent = b.brand;
  $('detailName').textContent  = b.name;
  const cat = $('detailCat');
  cat.textContent = b.cat;
  cat.setAttribute('style', catBadge(b.cat));

  // Only fields that are a property of the bag itself, from any source —
  // nothing that exists solely because one reviewer happened to cover it.
  const rows = [
    ['Volume',       b.vol != null ? fmtVol(b.vol) : null],
    ['Weight',       b.wt  != null ? fmtWt(b.wt)  : null],
    ['Dimensions',   b.dims],
    ['Material',     b.mat],
    ['Laptop fit',   b.laptop],
    ['Carry style',  b.carry && b.carry.length ? b.carry.join(', ') : null],
    ['Key features', b.feats && b.feats.length ? b.feats.join(' · ') : null],
  ];
  const known   = rows.filter(([, v]) => v);
  const unknown = rows.filter(([, v]) => !v).map(([k]) => k);

  $('detailBody').innerHTML = `
    <dl class="detail-grid">
      ${known.map(([k, v]) => `
        <div class="detail-row">
          <dt>${esc(k)}</dt>
          <dd>${esc(v)}</dd>
        </div>`).join('')}
    </dl>
    ${unknown.length ? `<p class="detail-missing">Not recorded: ${unknown.map(esc).join(', ')}.</p>` : ''}`;

  const sel = state.compare.includes(b.id);
  $('detailActions').innerHTML = `
    <button class="detail-cmp ${sel ? 'on' : ''}" onclick="toggleCompare(${b.id});openDetail(${b.id})">
      ${sel ? '✓ In comparison' : '+ Add to compare'}
    </button>
    <div class="detail-links">
      ${b.h ? `<a class="bag-head-link" target="_blank" rel="noopener"
           href="/products/${esc(b.h)}">Buy at UrbanCred →</a>` : ''}
      ${BRAND_RETAILERS[b.brand] ? `<a class="bag-head-link-alt" target="_blank" rel="noopener"
           href="${esc(BRAND_RETAILERS[b.brand].url)}">${esc(BRAND_RETAILERS[b.brand].label)} →</a>` : ''}
    </div>`;

  $('detailBg').classList.add('vis');
  document.body.style.overflow = 'hidden';
  $('detailBg').querySelector('.modal-close-btn').focus();
}

function closeDetail() {
  $('detailBg').classList.remove('vis');
  if (!anyModalOpen()) document.body.style.overflow = '';
  if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  lastFocus = null;
}

/* --- RELEASE NOTES --- */
function openNotes() {
  $('notesBody').innerHTML = RELEASES.map((r, i) => `
    <section class="rel ${i === 0 ? 'rel-current' : ''}">
      <div class="rel-hd">
        <span class="rel-v">v${esc(r.v)}</span>
        <span class="rel-date">${esc(r.date)}</span>
        ${i === 0 ? '<span class="rel-now">current</span>' : ''}
      </div>
      ${r.summary ? `<p class="rel-summary">${esc(r.summary)}</p>` : ''}
      <ul class="rel-notes">
        ${r.notes.map(n => `<li>${esc(n)}</li>`).join('')}
      </ul>
    </section>`).join('');
  $('notesBg').classList.add('vis');
  document.body.style.overflow = 'hidden';
  $('notesBg').querySelector('.modal-close-btn').focus();
}

function closeNotes() {
  $('notesBg').classList.remove('vis');
  if (!anyModalOpen()) document.body.style.overflow = '';
  $('verChip').focus();
}

/* --- TOGGLE COMPARE --- */
function toggleCompare(id) {
  const idx = state.compare.indexOf(id);
  if (idx >= 0) {
    state.compare.splice(idx, 1);
  } else {
    if (state.compare.length >= 4) {
      state.compare.shift(); // remove oldest
    }
    state.compare.push(id);
  }
  render();
}

/* --- VIEW TOGGLE --- */
function setView(v) {
  state.view = v;
  render();
}

// the toggle reflects state rather than being driven by the click, so the
// default view is correct on first paint too
function syncViewButtons() {
  $('gridBtn').classList.toggle('active', state.view === 'grid');
  $('tableBtn').classList.toggle('active', state.view === 'table');
}

/* --- MAIN RENDER --- */
function render() {
  const list = sorted(filtered());

  const empty = $('emptyState');
  const grid = $('bagGrid');
  const tblWrap = $('tableWrap');

  if (!list.length) {
    empty.style.display = 'block';
    grid.style.display = 'none';
    tblWrap.style.display = 'none';
  } else {
    empty.style.display = 'none';
    if (state.view === 'grid') {
      grid.style.display = 'grid';
      tblWrap.style.display = 'none';
      renderGrid(list);
    } else {
      grid.style.display = 'none';
      tblWrap.style.display = 'block';
      renderTable(list);
    }
  }

  syncViewButtons();
  renderSidebar();
  renderCompareBar();
  updateFilterBadge();
}

/* --- EVENT LISTENERS --- */
// Search
let searchTimer;
$('searchInput').addEventListener('input', e => {
  clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    state.search = e.target.value.trim();
    render();
  }, 200);
});

// Sort
$('sortSel').addEventListener('change', e => { state.sort = e.target.value; render(); });


// Volume range
$('volRange').addEventListener('input', e => {
  state.maxVol = +e.target.value;
  $('volLabel').textContent = e.target.value>=80 ? '80+ L' : e.target.value+'L';
  render();
});

// Reset
$('resetBtn').addEventListener('click', () => {
  state.search = ''; state.cats.clear(); state.brands.clear();
  state.maxVol=80;
  $('searchInput').value='';
  $('volRange').value=80; $('volLabel').textContent='80+ L';
  render();
});

/* ── Mobile filter drawer ── */
function setDrawer(open) {
  $('sidebar').classList.toggle('open', open);
  $('drawerBg').classList.toggle('vis', open);
  $('menuBtn').setAttribute('aria-expanded', open ? 'true' : 'false');
  document.body.style.overflow = open ? 'hidden' : '';
}
function drawerOpen() { return $('sidebar').classList.contains('open'); }
function toggleSidebar() {
  if (window.innerWidth <= 820) setDrawer(!drawerOpen());
  else {
    const hidden = $('sidebar').classList.toggle('collapsed');
    $('menuBtn').setAttribute('aria-expanded', hidden ? 'false' : 'true');
  }
}
$('menuBtn').addEventListener('click', toggleSidebar);
$('drawerBg').addEventListener('click', () => setDrawer(false));

// crossing the breakpoint must not strand the panel in the other mode's state
let wasNarrow = window.innerWidth <= 820;
window.addEventListener('resize', () => {
  const narrow = window.innerWidth <= 820;
  if (narrow === wasNarrow) return;
  wasNarrow = narrow;
  setDrawer(false);
  $('sidebar').classList.remove('collapsed');
  $('menuBtn').setAttribute('aria-expanded', 'true');
});

// Reflect how many filters are active, so the closed drawer isn't a black box
function updateFilterBadge() {
  const n = state.cats.size + state.brands.size + (state.maxVol < 80 ? 1 : 0);
  const badge = $('filterBadge');
  badge.hidden = n === 0;
  badge.textContent = n;
}

// Compare button
$('cmpGoBtn').addEventListener('click', openCompareModal);

// Close modal on background click
// Open the detail view from a card or a row. Delegated, because both lists are
// re-rendered wholesale on every filter change. The compare checkbox stops
// propagation itself, so ticking it never opens the record.
function bindOpeners(container, selector) {
  container.addEventListener('click', e => {
    const el = e.target.closest(selector);
    if (!el || e.target.closest('a')) return;
    openDetail(+el.dataset.id);
  });
  container.addEventListener('keydown', e => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const el = e.target.closest(selector);
    if (!el) return;
    e.preventDefault();
    openDetail(+el.dataset.id);
  });
}
bindOpeners($('bagGrid'), '.bag-card');
bindOpeners($('bagTableBody'), 'tr[data-id]');

$('detailBg').addEventListener('click', function(e) {
  if (e.target === this) closeDetail();
});

$('verChip').addEventListener('click', openNotes);
$('notesBg').addEventListener('click', function(e) {
  if (e.target === this) closeNotes();
});

$('modalBg').addEventListener('click', function(e) {
  if (e.target === this) closeModal();
});

// Table sort
$('bagTable').querySelectorAll('thead th[data-sort]').forEach(th => {
  th.addEventListener('click', () => {
    const col = th.dataset.sort;
    if (state.tableSort === col) {
      state.tableSortDir = state.tableSortDir === 'asc' ? 'desc' : 'asc';
    } else {
      state.tableSort = col; state.tableSortDir = 'asc';
    }
    $('bagTable').querySelectorAll('thead th').forEach(h => h.classList.remove('asc','desc'));
    th.classList.add(state.tableSortDir);

    const colMap = {name:'name',cat:'cat',vol:'vol',weight:'wt'};
    const key = colMap[col];
    if (!key) return;

    state.sort = col === 'vol' ? (state.tableSortDir==='asc'?'vol-asc':'vol-desc')
               : col === 'cat' ? (state.tableSortDir==='asc'?'cat-asc':'cat-desc')
               : col === 'name' ? 'name-asc'
               : col === 'brand' ? 'brand-asc'
               : state.sort;
    // keep the dropdown in sync, but never blank it on a value it has no option for
    // (e.g. cat-desc from toggling the Category column — it stays on "Bag Type", which is still true)
    if ([...$('sortSel').options].some(o => o.value === state.sort)) $('sortSel').value = state.sort;
    render();
  });
});

// ESC to close modal
// Escape unwinds one layer at a time: detail sits on top of compare.
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  if ($('notesBg').classList.contains('vis'))  { closeNotes();  return; }
  if ($('detailBg').classList.contains('vis')) { closeDetail(); return; }
  if ($('modalBg').classList.contains('vis'))  { closeModal();  return; }
  setDrawer(false);
});

/* --- INIT --- */
$('verNum').textContent = VERSION;
render();
